import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingState = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
      <Loader2 className="h-12 w-12 animate-spin text-blue-600" />
      <p className="text-gray-600 text-lg">{message}</p>
    </div>
  );
};

export default LoadingState;
